import React, { useContext, useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Table,
  Card,
  Spinner,
} from "react-bootstrap";
import "../../../assets/css/admin/marquee/marqueeInAdmin.css";
import AdminMasterLayout from "../../../layout/admin/AdminMasterLayout";
import axios from "axios";
import Swal from "sweetalert2";
import AppContext from "../../../context/AppContext";

const MarqueeInAdmin = () => {
  const { baseUrl, regTpChecker } = useContext(AppContext);
  const [btnLabel, setBtnLabel] = useState("Save");
  const [errorMessage, setErrorMessage] = useState("");
  const [idToUpdateDeletemarquee, setIdToUpdateDeletemarquee] = useState("");

  const [title, setTitle] = useState("");
  const [link, setLink] = useState("");
  const [marquee, setmarquee] = useState([]);

  const [items, setItems] = useState([]);
  const [addUploadLoading, setAddUploadLoading] = useState(false);
  const [loadingEditId, setLoadingEditId] = useState(null);
  const [loadingDeleteId, setLoadingDeleteId] = useState(null);

  const uploadmarquee = () => {
    console.log(title, link);
    const formData = new FormData();
    formData.append("title", title);
    formData.append("link", link);

    axios
      .post(`${baseUrl}/admin/marquee/uploadMarquee`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response.data);
        setAddUploadLoading(false);
        viewAllUploadedMarquee();
        resetForm();

        Swal.fire({
          icon: "success",
          title: "Congrats",
          text: "Marquee created and publised successfully",
          confirmButtonText: "Cool",
        });
      })
      .catch((err) => {
        console.log(err);
        setAddUploadLoading(false);
      });
  };
  // ---------------- FETCH Marquee ----------------
  const viewAllUploadedMarquee = () => {
    axios
      .get(`${baseUrl}/admin/marquee/viewAllUploadedMarquee`)
      .then((response) => setmarquee(response.data.marquee))
      .catch((error) => console.log(error));
  };
  const updateMarquee = () => {
    const formData = new FormData();
    formData.append("id", idToUpdateDeletemarquee);
    formData.append("title", title);
    formData.append("link", link);
    axios
      .post(`${baseUrl}/admin/marquee/updateMarquee`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(() => {
        viewAllUploadedMarquee();
        resetForm();
        setAddUploadLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setAddUploadLoading(false);
      });
  };
  const deleteMarquee = (idToDelete) => {
    const formData = new FormData();
    formData.append("id", idToDelete);
    axios
      .post(`${baseUrl}/admin/marquee/deleteMarquee`, formData)
      .then(() => {
        viewAllUploadedMarquee();
        setAddUploadLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setAddUploadLoading(false);
      });
  };
  // ---------------- RESET FORM ----------------
  const resetForm = () => {
    setTitle("");
    setLink("");
    setBtnLabel("Save");
    setIdToUpdateDeletemarquee("");
  };
  useEffect(() => {
    viewAllUploadedMarquee();
  }, []);

  return (
    <AdminMasterLayout>
      <Container fluid className="marquee-wrapper">
        {/* Header */}
        <div className="marquee-header">
          <div>
            <h3>Marquee Management</h3>
            <p>Manage the scrolling announcements on the public site</p>
          </div>
        </div>

        {/* Add Form */}
        <Card className="marquee-card">
          <h5>Add Marquee Item</h5>

          <Row className="g-3 mt-2">
            <Col md={6}>
              <Form.Label>Title</Form.Label>
              <Form.Control
                placeholder="Marquee text"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                  setErrorMessage(regTpChecker("marqueeTitle", e.target.value));
                }}
              />
            </Col>

            <Col md={6}>
              <Form.Label>Link (optional)</Form.Label>
              <Form.Control
                placeholder="/deals?type=instant"
                value={link}
                onChange={(e) => {
                  setLink(e.target.value);
                  // setErrorMessage(regTpChecker("marqueeLink", e.target.value));
                }}
              />
            </Col>
          </Row>

          <div className="text-start mt-3">
            {/*                           
                        <h4>
  {btnLabel === "Save"
    ? "Create New Marquee"
    : "Update Marquee"}
</h4> */}
            {/* Error Message */}
            {errorMessage && (
              <div className="buyer-error-message">{errorMessage}</div>
            )}
            <div className="mt-3">
              {addUploadLoading ? (
                <div className="text-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : btnLabel === "Save" ? (
                <button
                  type="button"
                  className="add-item-btn"
                  disabled={addUploadLoading || !title.trim() || !!errorMessage}
                  onClick={() => {
                    if (!title.trim() || errorMessage) return;

                    setAddUploadLoading(true);
                    uploadmarquee();
                  }}
                >
                  Add Item
                </button>
              ) : (
                <button
                  type="button"
                  className="add-item-btn"
                  disabled={addUploadLoading || !title.trim() || !!errorMessage}
                  onClick={() => {
                    if (!title.trim() || errorMessage) return;

                    setAddUploadLoading(true);
                    updateMarquee();
                  }}
                >
                  Update Marquee
                </button>
              )}
            </div>
          </div>
        </Card>

        {/* Table */}
        <Card className="marquee-card mt-3">
          <Table className="mb-0">
            <thead>
              <tr>
                <th>Title</th>
                <th>Link</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {marquee.map((item) => (
                <tr key={item.id}>
                  <td>{item.title}</td>
                  <td className="link">{item.link}</td>

                  <td>
                    <div className="action-group">
                      {/* EDIT BUTTON */}
                      <span
                        className="action-btn"
                        onClick={() => {
                          setLoadingEditId(item.id);

                          setIdToUpdateDeletemarquee(item.id);

                          setTitle(item.title);

                          setLink(item.link);

                          setBtnLabel("Update");

                          setTimeout(() => {
                            setLoadingEditId(null);
                          }, 500);
                        }}
                      >
                        {loadingEditId === item.id ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          "✏️"
                        )}
                      </span>

                      {/* DELETE BUTTON */}
                      <span
                        className="action-btn delete"
                        onClick={() => {
                          setLoadingDeleteId(item.id);

                          deleteMarquee(item.id);

                          setTimeout(() => {
                            setLoadingDeleteId(null);
                          }, 500);
                        }}
                      >
                        {loadingDeleteId === item.id ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          "🗑️"
                        )}
                      </span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card>
      </Container>
    </AdminMasterLayout>
  );
};

export default MarqueeInAdmin;
